<form [formGroup]="parentForm" class="column twelve">
  <div class="header pad-bottom-30 pad-top-20">Select vehicle make, model and series</div>

  <!-- <div class="error-600-text validation-error" *ngIf="parentForm.get('year').errors?.error">
  {{ parentForm.get('year').errors?.error }}
</div> -->

  <div class="sub-header pad-bottom-5">Make</div>
  <ds-form-control-container
    [labelText]="makeControl.valid ? '' : 'Select a Vehicle Make'"
    [control]="makeControl"
    [width]="200"
  >
    <select
      id="make"
      class="icon"
      formControlName="make"
      data-cy="replaceVehicleMakeSelect"
      (change)="loadModels()"
    >
      <!-- <option value="unset" selected disabled>Select a Vehicle Make</option> -->
      @for (make of makes; track make) {
        <option [value]="make">{{ make }}</option>
      }
      <option value="other">Other</option>
    </select>
    <span class="icon-chevron-down"></span>
  </ds-form-control-container>

  <div class="sub-header pad-top-10 pad-bottom-5">Model</div>
  <ds-form-control-container
    [labelText]="modelControl.valid ? '' : 'Select a Vehicle Model'"
    [control]="modelControl"
  >
    <select
      id="model"
      class="icon"
      formControlName="model"
      data-cy="replaceVehicleModelSelect"
      (change)="loadSeries()"
    >
      <!-- <option value="unset" selected disabled>Select a Vehicle Model</option> -->
      @for (model of models; track model) {
        <option [value]="model">{{ model }}</option>
      }
      <option value="other">Other</option>
    </select>
    <span class="icon-chevron-down"></span>
  </ds-form-control-container>

  @if (series?.length) {
    @if (series?.length) {
      <div class="sub-header pad-top-10 pad-bottom-5">Series</div>
    }
    @if (series?.length) {
      <ds-form-control-container
        [labelText]="seriesControl.valid ? '' : 'Select a Vehicle Series'"
        [control]="seriesControl"
      >
        <select
          id="series"
          class="icon"
          formControlName="series"
          data-cy="replaceVehicleSeriesSelect"
          (change)="onSeriesSelected()"
        >
          <!-- <option value="unset" selected disabled>Select a Vehicle Series</option> -->
          @for (vehicleSeries of series; track vehicleSeries) {
            <option [value]="vehicleSeries">
              {{ vehicleSeries }}
            </option>
          }
          <option value="other">Other</option>
        </select>
        <span class="icon-chevron-down"></span>
      </ds-form-control-container>
    }
  }

  @if (showMsrp) {
    <div class="msrp pad-top-20">
      <div class="header pad-top-10 pad-bottom-5">Review estimated vehicle price</div>
      <div class="sub-header pad-bottom-20 pad-top-20" id="msrpLabel">
        MSRP (manufacturer’s suggested retail price):
        {{ msrp | currency: 'USD' : 'symbol' : '1.0-2' }}.
      </div>
      <!-- <ds-amfam-dsn-alert
    [icon]="true"
    message="This is the Manufacturer Suggested Retail Price of your vehicle model."
    type="info"
    >
  </ds-amfam-dsn-alert> -->

      <div class="sub-header">Estimated Vehicle Price</div>
      <ds-form-control-container [control]="parentForm.controls['msrp']" [width]="400">
        <input type="text" id="msrp" class="" formControlName="msrp" (input)="onInput($event)" />
        <!-- <ds-form-control-message [control]="parentForm.get('msrp')"> </ds-form-control-message> -->
        @if (parentForm.get('msrp').touched && parentForm.get('msrp').invalid) {
          <div aria-live="assertive">
            @for (error of getFormControlErrors('msrp'); track error) {
              <div class="error flex items-center">
                <span class="icon-alert"></span> &nbsp; {{ error }}
              </div>
            }
          </div>
        }
      </ds-form-control-container>
      <div class="light pad-top-5">If you edit this amount, it can’t be lower than your MSRP.</div>
    </div>
  }
</form>
